import React from "react";
import { ApolloError } from "@apollo/client";
import classNames from "classnames";

import Graph from "ui/Graph";
import Loading from "ui/Loading";

import styles from "./style.module.scss";

type Props = {
  noData?: boolean;
  error?: ApolloError;
  loading?: boolean;
  className?: string;
  children: React.ReactNode;
};

const GraphSection = ({
  children,
  noData = false,
  loading = false,
  error,
  className,
}: Props) => {
  return (
    <div className={classNames(styles.sectionWrapper, className)}>
      {noData ? (
        <Graph data={{ "No Data": [] }} series={[]} />
      ) : loading || error ? (
        <Loading error={!!error} />
      ) : (
        children
      )}
    </div>
  );
};

export default GraphSection;
